import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { labels } from "../i18n/translations";

const navItemBase =
  "uppercase tracking-[0.22em] text-[11px] text-black/80 hover:text-[#C5A059] transition-colors duration-300";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: labels.nav.home, testId: "nav-home" },
    { to: "/catalogo", label: labels.nav.catalog, testId: "nav-catalog" },
    { to: "/contatti", label: labels.nav.contact, testId: "nav-contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/5"
    >
      <div className="px-6 md:px-12 lg:px-20 py-5 md:py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          aria-label="MB Réserve — Home"
          className="block shrink-0"
          onClick={() => setOpen(false)}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_fragranze-elite/artifacts/5b2gn3xy_ChatGPT%20Image%2022%20giu%202026%2C%2021_31_42.png"
            alt="MB Réserve"
            className="h-11 md:h-12 w-auto object-contain"
            loading="eager"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `${navItemBase} ${isActive ? "text-[#C5A059]" : ""}`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 -mr-2"
          aria-label="Toggle menu"
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-black/5 bg-white"
        >
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`${l.testId}-mobile`}
                className={({ isActive }) =>
                  `${navItemBase} text-sm ${isActive ? "text-[#C5A059]" : ""}`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
